function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "V7",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "3.0-Appointment-Detail",
  transform: "translate(-473.000000, -521.000000)",
  fill: "#444444",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(473.000000, 521.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.0555165,7.61844599 C11.4349965,7.2646873 11.4602952,6.65824384 11.1061138,6.27921668 C10.7519325,5.90018951 10.1447646,5.87492104 9.76528461,6.22867972 C9.73998595,6.2539482 9.73998595,6.2539482 9.71468728,6.27921668 L5.00913563,10.9791535 C3.89599438,12.0909665 3.89599438,13.8850284 5.00913563,14.9968414 C6.12227688,16.1086545 7.91848208,16.1086545 9.03162333,14.9968414 L12.3963457,11.6361339 L16.7477161,7.28995578 C18.417428,5.62223626 18.417428,2.91850916 16.7477161,1.25078964 C15.0780042,-0.41692988 12.3710471,-0.41692988 10.7013352,1.25078964 L6.37526353,5.62223626 L1.66971188,10.2969046 C-0.556570625,12.5205306 -0.556570625,16.1086545 1.66971188,18.3322805 C3.89599438,20.5559065 7.48840478,20.5559065 9.71468728,18.3322805 L15.7610682,12.2931143 C16.1405481,11.9393557 16.1658468,11.3329122 15.8116655,10.953885 C15.4574842,10.5748579 14.8503162,10.5495894 14.4708363,10.9033481 C14.4455376,10.9286166 14.4455376,10.9286166 14.4202389,10.953885 L8.37385805,16.9930512 C6.85593816,18.4586229 4.452565,18.4080859 3.01054111,16.8919773 C1.59381588,15.4264056 1.59381588,13.1017056 3.01054111,11.6361339 L7.71609276,6.93619709 L12.0674631,2.59001895 C13.0035137,1.65508528 14.4961349,1.65508528 15.4321855,2.59001895 C16.3682361,3.52495262 16.3682361,5.0157928 15.4321855,5.95072647 L15.4321855,5.95072647 L11.0555165,10.2969046 L7.71609276,13.6576121 C7.33661279,14.0113708 6.72944483,13.9861023 6.37526353,13.6070752 C6.04638089,13.2533165 6.04638089,12.6721415 6.37526353,12.3183828 L11.0555165,7.61844599 Z",
  id: "icon_attachment"
}))));

function SvgIconAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B9496E43-FE6C-4A3E-B698-D39220C4B4BB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachment);
export default __webpack_public_path__ + "static/media/icon_attachment.5879581f.svg";
export { ForwardRef as ReactComponent };